import { Component, Input } from '@angular/core';
import jsPDF from 'jspdf';
import { ESTAMP_CURLS, ESIGN_CURLS, ESTAMP_ENDPOINTS, ESIGN_ENDPOINTS } from './documentData';

@Component({
    selector: 'app-documentataion',
    templateUrl: './documentataion.component.html',
    styleUrl: './documentataion.component.scss',
    standalone: false
})
export class DocumentataionComponent {
  @Input() activeTab: string = ''

  curlCreateDoc = ESIGN_CURLS.sendDocument;
  curlStatusDoc = ESIGN_CURLS.documentStatus;
  curlDownloadDoc = ESIGN_CURLS.downloadDocument;
  curlAllDoc = ESIGN_CURLS.allDocuments;
  curlDoc = ESIGN_CURLS.documentById;
  curlCreateDocWithTempId = ESIGN_CURLS.sendDocumentWithTemplate;

  estampStateList = ESTAMP_CURLS.stateList;
  createEstampOrder = ESTAMP_CURLS.createOrder;
  estampOrderList = ESTAMP_CURLS.orderList;
  estampInventoryList = ESTAMP_CURLS.inventoryList;
  estampOrderDetail = ESTAMP_CURLS.orderDetail;

  copiedKey: string | null = null;

  copyToClipboard(text: string, key: string) {
    navigator.clipboard.writeText(text).then(() => {
      this.copiedKey = key;

      setTimeout(() => {
        this.copiedKey = null;
      }, 2000);
    });
  }

  viewDoc = false;

  viewDocumentataion() {
    this.viewDoc = !this.viewDoc;
  }

  downloadEstampCurls() {
    const doc = new jsPDF();
    let yPosition = 20;
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const margin = 15;
    const maxWidth = pageWidth - 2 * margin;

    doc.setFontSize(16);
    doc.setFont('', 'bold');
    doc.text('eSTAMP API - CURL COMMANDS', margin, yPosition);
    yPosition += 15;

    const endpoints = ESTAMP_ENDPOINTS;

    endpoints.forEach((endpoint) => {
      if (yPosition > pageHeight - 50) {
        doc.addPage();
        yPosition = 20;
      }

      doc.setFontSize(12);
      doc.setFont('', 'bold');
      doc.text(endpoint.title, margin, yPosition);
      yPosition += 8;

      doc.setFontSize(9);
      doc.setFont('', 'normal');
      const descLines = (doc.splitTextToSize(endpoint.description, maxWidth) || []) as string[];
      descLines.forEach((line) => {
        if (yPosition > pageHeight - 20) {
          doc.addPage();
          yPosition = 20;
        }
        doc.text(line, margin, yPosition);
        yPosition += 4;
      });

      yPosition += 3;

      doc.setFontSize(8);
      doc.setFont('', 'normal');
      const curlLines = (doc.splitTextToSize(endpoint.curl, maxWidth) || []) as string[];
      curlLines.forEach((line) => {
        if (yPosition > pageHeight - 20) {
          doc.addPage();
          yPosition = 20;
        }
        doc.text(line, margin, yPosition);
        yPosition += 4;
      });

      yPosition += 5;

      doc.setFontSize(8);
      doc.setFont('', 'italic');
      endpoint.notes.forEach((note) => {
        const noteLines = (doc.splitTextToSize(`• ${note}`, maxWidth - 5) || []) as string[];
        noteLines.forEach((line) => {
          if (yPosition > pageHeight - 20) {
            doc.addPage();
            yPosition = 20;
          }
          doc.text(line, margin + 3, yPosition);
          yPosition += 4;
        });
      });

      yPosition += 5;
    });

    doc.save('eStamp-API-Curls.pdf');
  }

  downloadEsignCurls() {
    const doc = new jsPDF();
    let yPosition = 20;
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const margin = 15;
    const maxWidth = pageWidth - 2 * margin;

    doc.setFontSize(16);
    doc.setFont('', 'bold');
    doc.text('eSign API - CURL COMMANDS', margin, yPosition);
    yPosition += 15;

    const endpoints = ESIGN_ENDPOINTS;

    endpoints.forEach((endpoint) => {
      if (yPosition > pageHeight - 50) {
        doc.addPage();
        yPosition = 20;
      }

      doc.setFontSize(12);
      doc.setFont('', 'bold');
      doc.text(endpoint.title, margin, yPosition);
      yPosition += 8;

      doc.setFontSize(9);
      doc.setFont('', 'normal');
      const descLines = (doc.splitTextToSize(endpoint.description, maxWidth) || []) as string[];
      descLines.forEach((line) => {
        if (yPosition > pageHeight - 20) {
          doc.addPage();
          yPosition = 20;
        }
        doc.text(line, margin, yPosition);
        yPosition += 4;
      });

      yPosition += 3;

      doc.setFontSize(8);
      doc.setFont('', 'normal');
      const curlLines = (doc.splitTextToSize(endpoint.curl, maxWidth) || []) as string[];
      curlLines.forEach((line) => {
        if (yPosition > pageHeight - 20) {
          doc.addPage();
          yPosition = 20;
        }
        doc.text(line, margin, yPosition);
        yPosition += 4;
      });

      yPosition += 5;

      if (endpoint.notes.length > 0) {
        doc.setFontSize(8);
        doc.setFont('', 'italic');
        endpoint.notes.forEach((note) => {
          const noteLines = (doc.splitTextToSize(`• ${note}`, maxWidth - 5) || []) as string[];
          noteLines.forEach((line) => {
            if (yPosition > pageHeight - 20) {
              doc.addPage();
              yPosition = 20;
            }
            doc.text(line, margin + 3, yPosition);
            yPosition += 4;
          });
        });
      }

      yPosition += 5;
    });

    doc.save('eSign-API-Curls.pdf');
  }

  downloadEstampPostmanCollection() {
    const collection = {
      info: {
        name: 'eSTAMP API Collection',
        description: 'Complete eSTAMP API endpoints for Postman import',
        schema: 'https://schema.getpostman.com/json/collection/v2.1.0/collection.json'
      },
      item: ESTAMP_ENDPOINTS.map((endpoint) => {
        const { method, path, query } = endpoint.postman;
        const queryString = query.length
          ? `?${query.map((param) => `${param.key}=${param.value}`).join('&')}`
          : '';

        const request: any = {
          method,
          header: [
            { key: 'x-api-key', value: 'besk_YOUR_API_KEY_HERE' }
          ],
          url: {
            raw: `{{baseUrl}}/${path.join('/')}${queryString}`,
            host: ['{{baseUrl}}'],
            path,
            query
          }
        };

        const formdata = (endpoint.postman as any).formdata;
        if (formdata) {
          request.body = { mode: 'formdata', formdata };
        }

        return {
          name: endpoint.title,
          description: endpoint.description,
          request
        };
      })
    };

    this.downloadJSON(collection, 'eSTAMP-API-Postman-Collection.json');
  }

  downloadEsignPostmanCollection() {
    const collection = {
      info: {
        name: 'eSign API Collection',
        description: 'Complete eSign API endpoints for Postman import',
        schema: 'https://schema.getpostman.com/json/collection/v2.1.0/collection.json'
      },
      item: ESIGN_ENDPOINTS.map((endpoint, index) => {
        const isSendRequest = index === 0 || index === 5;
        const request: any = {
          method: isSendRequest ? 'POST' : 'GET',
          header: [
            { key: 'x-api-key', value: 'sk_YOUR_API_KEY_HERE' }
          ],
          url: {
            raw: index === 0 ? '{{baseUrl}}/documents-api/send' :
              index === 1 ? '{{baseUrl}}/documents-api/{{documentId}}/status' :
                index === 2 ? '{{baseUrl}}/documents-api/{{documentId}}/download' :
                  index === 3 ? '{{baseUrl}}/documents-api?page=1&limit=10' :
                    index === 4 ? '{{baseUrl}}/documents-api/{{documentId}}' :
                      '{{baseUrl}}/documents-api/send/{{templateId}}',
            host: ['{{baseUrl}}'],
            path: index === 0 ? ['documents-api', 'send'] :
              index === 1 ? ['documents-api', '{{documentId}}', 'status'] :
                index === 2 ? ['documents-api', '{{documentId}}', 'download'] :
                  index === 3 ? ['documents-api'] :
                    index === 4 ? ['documents-api', '{{documentId}}'] :
                      ['documents-api', 'send', '{{templateId}}'],
            query: index === 3 ? [
              { key: 'page', value: '1' },
              { key: 'limit', value: '10' }
            ] : []
          }
        };

        if (index === 0) {
          request.body = {
            mode: 'formdata',
            formdata: [
              { key: 'file', value: '', type: 'file', disabled: false },
              { key: 'name', value: 'Loan Agreement - Rajesh Kumar', type: 'text' },
              { key: 'signers', value: '[{"name":"test","email":"test@example.com","phone":"9876543210","esignType":"1","signatureDetail":[{"page":"1","coordinates":[{"x":449,"y":273,"w":200,"h":100}]}]}]', type: 'text' },
              { key: 'signingOrder', value: 'sequential', type: 'text' },
              { key: 'livePhoto', value: 'true', type: 'text' },
              { key: 'message', value: 'Please sign this loan agreement document', type: 'text' }
            ]
          };
        } else if (index === 5) {
          request.body = {
            mode: 'formdata',
            formdata: [
              { key: 'file', value: '', type: 'file', disabled: false },
              { key: 'signers', value: '[{"name":"test","email":"test@example.com","phone":"9876543210","esignType":"1"}]', type: 'text' },
              { key: 'livePhoto', value: 'true', type: 'text' },
              { key: 'signingOrder', value: 'sequential', type: 'text' }
            ]
          };
        }

        return {
          name: endpoint.title,
          description: endpoint.description,
          request
        };
      })
    };

    this.downloadJSON(collection, 'eSign-API-Postman-Collection.json');
  }

  private downloadJSON(data: any, filename: string) {
    const jsonString = JSON.stringify(data, null, 2);
    const blob = new Blob([jsonString], { type: 'application/json' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
    window.URL.revokeObjectURL(url);
  }

}
